import React, { useState, useEffect } from "react";
import { Form, Menu, Dropdown, Input, Button, Col, Row } from "antd";
import {
  DownOutlined,
  SearchOutlined,
  FilterOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";

function FilterMenu(props) {
  const [filterForm] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedDataSession, setSelectedDataSession] = useState("");
  const [selectedRAT, setSelectedRAT] = useState("");
  const [selectedStatusKey, setSelectedStatusKey] = useState("");
  const [selectedDataSessionKey, setSelectedDataSessionKey] = useState("");
  const [selectedRATKey, setSelectedRATKey] = useState("");
  const [search, setSearch] = useState("");

  const getSelectedLabel = (key, defaultLabel) => {
    const selectedItem = items.find(
      (item) => item.key === searchParams.get(key)
    );
    return selectedItem ? selectedItem.label : defaultLabel;
  };

  useEffect(() => {
    setSearch(searchParams.get("search") ?? "");
    setSelectedStatus(getSelectedLabel("status", "All"));
    setSelectedDataSession(getSelectedLabel("session", "All"));
    setSelectedRAT(getSelectedLabel("ratType", "All"));
  }, []);

  const handleMenuClick = (e) => {
    const selectedItem = items.find((item) => item.key === e.key);
    if (!selectedItem) return;

    // const newParams = {
    //   ...Object.fromEntries(searchParams.entries()),
    //   [selectedItem.by === "status"
    //     ? "status"
    //     : selectedItem.by === "session"
    //     ? "session"
    //     : "ratType"]: selectedItem.label,
    // };

    // setSearchParams(newParams);

    if (selectedItem.by === "status") {
      setSelectedStatus(selectedItem.label);
      setSelectedStatusKey(selectedItem.key);
    }
    if (selectedItem.by === "session") {
      setSelectedDataSession(selectedItem.label);
      setSelectedDataSessionKey(selectedItem.key);
    }

    if (selectedItem.by === "rat") {
      setSelectedRAT(selectedItem.label);
      setSelectedRATKey(selectedItem.key);
    }
  };

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onSetFilter = () => {
    const newParams = {
      ...Object.fromEntries(searchParams.entries()),
      search,
      ...(selectedStatusKey && { status: selectedStatusKey }),
      ...(selectedDataSessionKey && { session: selectedDataSessionKey }),
      ...(selectedRATKey && { ratType: selectedRATKey }),
    };

    setSearchParams(newParams);
    props.onGetQuery(newParams);
  };

  const items = [
    {
      key: "ALL-STATUS",
      label: "All",
      by: "status",
    },
    {
      key: "ALL-SESSION",
      label: "All",
      by: "session",
    },
    {
      key: "ALL-RATTYPE",
      label: "All",
      by: "rat",
    },
    {
      key: "IN-BILLING",
      label: "In Billing",
      by: "status",
    },
    {
      key: "IN-TESTING",
      label: "In Testing",
      by: "status",
    },
    {
      key: "BILLING-READY",
      label: "Billing Ready",
      by: "status",
    },
    {
      key: "SUSPENDED",
      label: "Suspended",
      by: "status",
    },
    {
      key: "RETIRED",
      label: "Retired",
      by: "status",
    },
    {
      key: "ONLINE",
      label: "Online",
      by: "session",
    },
    {
      key: "OFFLINE",
      label: "Offline",
      by: "session",
    },
    {
      key: "REJECTED",
      label: "Rejected",
      by: "session",
    },
    {
      key: "NEVER-ONLINE",
      label: "Never Online",
      by: "session",
    },
    {
      key: "UMTS",
      label: "UMTS",
      by: "rat",
    },
    {
      key: "EDGE",
      label: "EDGE",
      by: "rat",
    },
    {
      key: "WLAN",
      label: "WLAN",
      by: "rat",
    },
    {
      key: "GAN",
      label: "GAN",
      by: "rat",
    },
    {
      key: "HSPA-REVOLUTION",
      label: "HSPA Revolution",
      by: "rat",
    },
    {
      key: "LTE",
      label: "LTE",
      by: "rat",
    },
    {
      key: "EURAN-NB-IOT",
      label: "EURAN NB IoT",
      by: "rat",
    },
    {
      key: "LTE-M",
      label: "LTE-M",
      by: "rat",
    },
    {
      key: "5G-NR",
      label: "5G NR",
      by: "rat",
    },
  ];

  const clearFilter = () => {
    setSelectedStatus("All");
    setSelectedRAT("All");
    setSelectedDataSession("All");
    setSelectedStatusKey("");
    setSelectedRATKey("");
    setSelectedDataSessionKey("");
    setSearch("");
    setSearchParams();
    filterForm.resetFields();

    props.onGetQuery();
  };

  const menu = (type) => {
    return (
      <Menu selectable onClick={handleMenuClick}>
        {items
          .filter((data) => data.by === type)
          .map((item) => (
            <Menu.Item key={item.key}>{item.label}</Menu.Item>
          ))}
      </Menu>
    );
  };

  return (
    <Row gutter={[8, 16]} align={"middle"}>
      <Col xs={24} md={7} lg={4}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Status</div>
        <Dropdown overlay={menu("status")} trigger={["click"]}>
          <Input
            readOnly
            value={selectedStatus}
            suffix={<DownOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
            placeholder="Select Status"
            style={{ cursor: "pointer" }}
          />
        </Dropdown>
      </Col>
      <Col xs={24} md={7} lg={4}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Data Session</div>
        <Dropdown overlay={menu("session")} trigger={["click"]}>
          <Input
            readOnly
            value={selectedDataSession}
            suffix={<DownOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
            placeholder="Select Session"
            style={{ cursor: "pointer" }}
          />
        </Dropdown>
      </Col>
      <Col xs={24} md={7} lg={4}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>RAT Type</div>
        <Dropdown overlay={menu("rat")} trigger={["click"]}>
          <Input
            readOnly
            value={selectedRAT}
            suffix={<DownOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
            placeholder="Select RAT Type"
            style={{ cursor: "pointer" }}
          />
        </Dropdown>
      </Col>
      <Col xs={24} md={7} lg={4}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Search</div>
        <Input
          type="text"
          prefix={<SearchOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
          placeholder="Search..."
          value={search}
          onChange={onChange}
        />
      </Col>
      <Col xs={24} md={7} lg={8}>
        <div style={{ fontWeight: 600, marginBottom: 8, color: "#fff" }}>
          Filter
        </div>
        <Row gutter={[8, 16]} align={"middle"}>
          <Col>
            <Button icon={<CloseOutlined />} onClick={clearFilter}>
              Clear
            </Button>
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<FilterOutlined />}
              onClick={onSetFilter}
            >
              Filter
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default FilterMenu;
